import { ResearchRole } from '../shared/global-enums';
import { isArray } from './get-type.utils';

export const translateRoles = (userScope: string | string[]): string => {
    return translateRolesFromArray(
        isArray(userScope) ? userScope : userScope.split(' ')
    );
};

const translateRolesFromArray = (userScopes: string[]): ResearchRole => {
    if (userScopes.some((x) => x === 'admin:insights'))
        return ResearchRole[ResearchRole.Administrator];
    if (userScopes.some((x) => x === 'insights:content-publish'))
        return ResearchRole[ResearchRole.Editor];
    if (userScopes.some((x) => x === 'insights:content-edit'))
        return ResearchRole[ResearchRole.Contributor];

    // assume all other users that have accessed the system are subscribers
    return ResearchRole[ResearchRole.Subscriber];
};

export const trialScope = 'insights:content-reader-trial';
export const nonTrialScopes = [
    'admin:insights',
    'insights:content-publish',
    'insights:content-edit',
    'insights:content-reader',
];

export const getRolesFromScope = (userScope: string): ResearchRole[] => {
    const scopeArray = isArray(userScope) ? userScope : userScope.split(' ');
    const roles: ResearchRole[] = [];

    if (scopeArray.some((x) => x === 'admin:insights'))
        roles.push(ResearchRole[ResearchRole.Administrator]);
    if (scopeArray.some((x) => x === 'insights:content-publish'))
        roles.push(ResearchRole[ResearchRole.Editor]);
    if (scopeArray.some((x) => x === 'insights:content-edit'))
        roles.push(ResearchRole[ResearchRole.Contributor]);
    if (
        scopeArray.some(
            (x) => x === 'insights:content-reader' || x === trialScope
        )
    )
        roles.push(ResearchRole[ResearchRole.Subscriber]);

    return roles;
};
